import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import apiUrl from '.';

function calculateTotal(order) {
    // Sum of (price * quantity) for each product
    const totalProductPrice = order.product.reduce((total, item) => {
        return total + (item.price * item.qty);
    }, 0);

    // Apply discount
    const finalTotal = totalProductPrice - order.discount;
    return finalTotal;
}

const fetchOrders = createAsyncThunk(
    'order/fetchOrders',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(apiUrl+'/api/keeus/order'); // Update this URL with your actual endpoint
            // console.log(response.data)
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

const fetchOrder = createAsyncThunk(
    'order/fetchOrder',
    async (orderId, { rejectWithValue }) => {
        try {
            const res = await axios.get(apiUrl+'/api/keeus/order/'+orderId); // Update this URL with your actual endpoint
            console.log(res)
            const order=res.data.data;
            console.log(order)
            
            // response = await axios.get(apiUrl+'/api/keeus/order/'+orderId); // Update this URL with your actual endpoint
            // const order = response.data.find(order => order.id === orderId);
            const totalPrice = calculateTotal(order);
            order.totalPrice = totalPrice;
            // console.log(order)

            return order;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export { fetchOrders, fetchOrder };
